{
  "login": {
    "title": "Admin Backoffice",
    "signInWithGoogle": "Sign in with Google",
    "signingIn": "Signing in...",
    "completeInPopup": "Complete sign-in in the popup window",
    "refocusPopup": "Click to bring back the sign-in window",
    "cancel": "Cancel",
    "restrictedAccess": "Restricted access — pre-registered accounts only."
  },
  "callback": {
    "completingSignIn": "Completing sign-in..."
  },
  "errors": {
    "USER_NOT_FOUND": "No account found for this Google account. Access is by invitation only.",
    "ACCOUNT_INACTIVE": "Your account has been suspended or deactivated. Please contact an administrator.",
    "generic": "Something went wrong. Please try again."
  }
}
